/**
 * Auction Price Formatter
 * Trims unnecessary ".00" decimals from auction prices for cleaner display.
 * Loaded via theme.liquid, runs after AuctionPlus app renders prices.
 */
(function() {
  'use strict';

  function trimPrices() {
    document.querySelectorAll('auction-info .text-lg').forEach(function(el) {
      if (el.dataset.priceTrimmed) return;
      var text = el.textContent.trim();
      if (text.endsWith('.00')) {
        // Only trim .00 on amounts >= 1,000 where space savings matters
        var num = parseFloat(text.replace(/[^0-9.]/g, ''));
        if (num >= 1000) {
          el.textContent = text.slice(0, -3);
        }
        el.dataset.priceTrimmed = '1';
      }
    });
  }

  // Watch for auction-info content appearing (app renders async)
  new MutationObserver(trimPrices)
    .observe(document.body, { childList: true, subtree: true });

  // Safety-net passes for slow-loading auction data
  trimPrices();
  setTimeout(trimPrices, 1500);
  setTimeout(trimPrices, 4000);
})();
